import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, FilePenLine, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

// Shown at the top of every employee page while HR has sent a letter that is
// waiting for the employee to accept (or acknowledge). Red once it's overdue.
export default function LetterBanner() {
  const { pathname } = useLocation();
  const { data } = useQuery({
    queryKey: ["myLetterStatus"],
    queryFn: async () => (await api.get("/my/letters/status")).data,
    refetchInterval: 5 * 60 * 1000,
    retry: false,
  });
  if (!data || !data.pending || pathname.startsWith("/letters")) return null;
  const overdue = data.overdue > 0;
  return (
    <Link to="/letters" data-testid="letter-banner"
      className={cn("mb-5 flex items-center gap-3 rounded-lg border px-4 py-3 text-sm transition-colors",
        overdue ? "border-red-300 bg-red-50 text-red-800 hover:bg-red-100" : "border-teal/40 bg-teal/5 text-navy hover:bg-teal/10")}>
      {overdue ? <AlertTriangle className="h-5 w-5 shrink-0" /> : <FilePenLine className="h-5 w-5 shrink-0 text-teal" />}
      <p className="flex-1">
        <span className="font-semibold">HR has sent you {data.pending === 1 ? "a letter" : `${data.pending} letters`} to accept.</span>{" "}
        {overdue ? "The respond-by date has passed — please open it now." : "Open it, read it and accept it online — no printing needed."}
      </p>
      <span className="hidden sm:inline-flex items-center gap-1 font-semibold whitespace-nowrap">Open <ArrowRight className="h-4 w-4" /></span>
    </Link>
  );
}
